import React, {useEffect} from 'react';

import {Form, Input, Button, Radio, Upload, Checkbox, Row, Col, Typography, Select, DatePicker, Divider, Alert, InputNumber, Card, Modal, message} from 'antd';
import Flex from '../Flex';
const {Text, Title, Paragraph} = Typography;

import {useBoolean, useInput, useNumber} from 'react-hanger';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {AuthorizeApi, UserApi} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import useAuth from '../../utils/AuthContext';
import {useHistory} from 'react-router-dom';

const UserLoginForm = () => {
  const loginState = useOpenApiFpRequest(AuthorizeApi, AuthorizeApi.prototype.authorizeLoginPost);
  const getPasswordState = useOpenApiFpRequest(UserApi, UserApi.prototype.userGetDefaultPasswordPost);
  const username = useInput('');
  const email = useInput('');
  const password = useInput('');
  const isOpen = useBoolean(false);
  const history = useHistory();
  const auth = useAuth();
  function login() {
    loginState
      .request({
        authorizeLoginParams: {
          username: username.value,
          password: password.value,
        },
      })
      .then(res => {
        localStorage.setItem('Application-Token', res.body || '');
        history.push('/');
        setTimeout(() => {
          auth.setToken(res.body || '');
          res.user && auth.setCurrentUser(res.user);
        }, 1500);
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <Card title={'登录'}>
      <Form labelCol={{span: 6}} wrapperCol={{span: 14}} layout={'horizontal'}>
        <Form.Item label={'用户名'} name={'username'} required>
          <Input size={'large'} placeholder="工号或者学号" {...username.eventBind} />
        </Form.Item>
        <Form.Item label={'密码'} name={'password'} required>
          <Input.Password size={'large'} placeholder="请输入密码" {...password.eventBind} />
        </Form.Item>
        <Row>
          <Col span={6} />
          <Col>
            <Button className={'m-r-10'} size={'large'} type="primary" loading={loginState.loading} onClick={login}>
              立即登录
            </Button>
            <Button size={'large'} onClick={isOpen.setTrue}>
              找回密码
            </Button>
          </Col>
        </Row>
      </Form>
      <Modal
        visible={isOpen.value}
        title={'找回密码'}
        onCancel={isOpen.setFalse}
        okText={'发送找回邮件'}
        cancelText={'取消'}
        okButtonProps={{disabled: !email.value, loading: getPasswordState.loading}}
        onOk={async () => {
          try {
            await getPasswordState.request({userGetDefaultPasswordParams: {email: email.value}});
            message.success('找回密码邮件已发送，请查收');
            isOpen.setFalse();
          } catch (e) {
            CommonApiErrorHandler(e);
          }
        }}>
        <Form>
          <Form.Item label={'电子邮箱'}>
            <Input size={'large'} placeholder={'请输入您的系统邮箱'} {...email.eventBind} />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default UserLoginForm;
